/**
 * TypeBadge - Shared Component
 * 
 * Displays Pokémon type with consistent styling.
 * Used across Pokédex, PvP, Events, and all sections.
 * 
 * Design System: Identity Component - Universal
 */

import React from 'react';

const getTypeColor = (type) => {
  if (!type) return 'bg-gray-500';
  
  const typeLower = type.toLowerCase();
  const typeColors = {
    'normal': 'bg-gray-500',
    'fire': 'bg-red-500',
    'water': 'bg-blue-500',
    'electric': 'bg-yellow-500',
    'grass': 'bg-green-500',
    'ice': 'bg-cyan-500',
    'fighting': 'bg-orange-500',
    'poison': 'bg-purple-500',
    'ground': 'bg-amber-600',
    'flying': 'bg-sky-500',
    'psychic': 'bg-pink-500',
    'bug': 'bg-lime-500',
    'rock': 'bg-stone-500',
    'ghost': 'bg-purple-600',
    'dragon': 'bg-indigo-600',
    'dark': 'bg-gray-700',
    'steel': 'bg-gray-400',
    'fairy': 'bg-pink-400',
    'none': 'bg-gray-400'
  };
  
  return typeColors[typeLower] || 'bg-gray-500';
};

const TypeBadge = ({
  type,
  size = 'default', // 'small' | 'default' | 'large'
  showIcon = true, // Show type icon
  className = ''
}) => {
  if (!type || type === 'none') return null;

  const sizeClasses = {
    small: 'px-2 py-0.5 text-xs',
    default: 'px-2 py-0.5 text-xs',
    large: 'px-3 py-1 text-sm'
  };

  const iconSizes = {
    small: 'w-3 h-3',
    default: 'w-4 h-4',
    large: 'w-5 h-5'
  };

  const typeLower = type.toLowerCase();
  const iconPath = `/images/Types/${type.charAt(0).toUpperCase() + typeLower.slice(1)}.webp`;

  return (
    <span 
      className={`inline-flex items-center gap-1.5 ${sizeClasses[size]} font-medium text-white rounded-full ${getTypeColor(type)} ${className}`}
    >
      {showIcon && (
        <img 
          src={iconPath}
          alt={type}
          className={`${iconSizes[size]} object-contain flex-shrink-0`}
          onError={(e) => {
            // Hide icon if not found, but keep text
            e.target.style.display = 'none';
          }}
        />
      )}
      <span>{type}</span>
    </span>
  );
};

export default TypeBadge;
